/**
 * Non-hook notification API for components that need to signal notification updates
 * Triggers API refresh instead of managing local count
 */

// Simple notification API that signals for API refresh
export const notificationAPI = {
  // Signal that a notification was resolved (application approved/rejected)
  resolveNotification: async (notificationId: string) => {
    try {
      console.log('✅ Notification resolved:', notificationId);
      
      // Trigger custom event to signal NotificationBell to refresh from API
      window.dispatchEvent(new CustomEvent('notificationUpdate', {
        detail: { type: 'resolved', notificationId }
      }));
      
    } catch (error) {
      console.error('❌ Error signaling notification resolution:', error);
    }
  },

  // Signal that a new notification was received
  addNotification: async (notification: any) => {
    try {
      console.log('🔔 New notification added:', notification);
      
      // Trigger custom event to signal NotificationBell to refresh from API
      window.dispatchEvent(new CustomEvent('notificationUpdate', {
        detail: { type: 'added', notification }
      }));
      
    } catch (error) {
      console.error('❌ Error signaling new notification:', error);
    }
  },

  // Force refresh the notification count from API
  refreshNotifications: () => {
    console.log('🔄 Forcing notification refresh from API');
    window.dispatchEvent(new CustomEvent('notificationUpdate', {
      detail: { type: 'refresh' }
    }));
  },

  // Mark all notifications as read on backend
  markAllAsRead: async () => {
    try {
      console.log('📤 Marking all notifications as read via API');
      const { notificationsService } = await import('../services');
      const success = await notificationsService.markAllAsRead();
      
      if (success) {
        console.log('✅ All notifications marked as read on backend');
        // Trigger refresh to update count
        window.dispatchEvent(new CustomEvent('notificationUpdate', {
          detail: { type: 'markAllRead' }
        }));
      }
      
      return success;
    } catch (error) {
      console.error('❌ Error marking all notifications as read:', error);
      return false;
    }
  }
};